<div class="sidebar">
    <div class="logo-section" (click)="navigateToHome()">
        <img src="assets/conectio-logo-white.png" alt="Conectio" class="logo">
    </div>

    <div class="menu-section">
    </div>
    
    <div class="footer">
        <div class="legal-links">
            <a href="https://conectio.io/#contact" rel="nofollow">{{ 'footer.legal.contact' | translate }}</a>
            <a href="https://conectio.io/legal-advise" rel="nofollow">{{ 'footer.legal.legalNotice' | translate }}</a>
            <a href="https://conectio.io/terms-conditions" rel="nofollow">{{ 'sidebar.legal.termsConditions' | translate }}</a>
            <a href="https://conectio.io/cookie-policy" rel="nofollow">{{ 'footer.legal.cookiePolicy' | translate }}</a>
            <a href="https://conectio.io/privacy-policy" rel="nofollow">{{ 'footer.legal.privacyPolicy' | translate }}</a>
        </div>
        <p>{{ 'footer.copyright' | translate }}</p>
        <p>{{ 'footer.company' | translate }}</p>
        <p>{{ 'footer.rights' | translate }}</p>
    </div>
</div>

